import axios from "axios";
import { API } from "../../utils";
const instance = axios.create();

export const getCategories = async () => {
  return instance.get(`${API}/category`);
};
